import http from '../core/http-common'
import { MailSetting, MailSettingResponse, MailSettingRequest } from '../types/MailSetting'

class MailSettingService {
  updateSaveMailSetting(request: MailSettingRequest) {
    return http.post<MailSettingResponse>('/MailSetting/SaveMailSetting', request)
  }

  updateSaveMailSettingForManager(request: MailSettingRequest) {
    return http.post<MailSettingResponse>('/MailSetting/SaveMailSettingForManager', request)
  }

  getMailSetting() {
    return http.get<MailSettingResponse>('/MailSetting/GetMailSetting')
  }

  getMailSettingForManager() {
    return http.get<MailSettingResponse>('/MailSetting/GetMailSettingForManager')
  }
}

export default new MailSettingService()
